import React from 'react'
import PropTypes from 'prop-types'
import { localsMessages } from '../utility/getTemplateData'
import { getCountryInfo } from '../utility/localizer'
import { setCountryAndLocale } from '../utility/helper'
import { Checkbox } from '@paypalcorp/pp-react-checkbox';
import spanWithHtml from '../guest-payment-components/SpanWithHtml';

const messages = localsMessages('common/guestTerms')

class GuestTerms extends React.Component {

	constructor(props) {
		super(props);
		this.state = {
			isChecked: !!this.props.isChecked
		};
	}

	createMarkup = () => {
		return { __html: setCountryAndLocale(messages.terms) };
	}

	createMarkupSpan = () => {
		return spanWithHtml(setCountryAndLocale(messages.terms))
	}


	onChange = (event) => {
		const isChecked = event.target.checked
		this.setState({ isChecked })
		this.props.handleRequired(isChecked);
	}

	render () {
		const countryInfo = getCountryInfo(this.props.country);

		if (this.props.mandatory) {
			return null;
		}

		return (
			<React.Fragment>
				{
					countryInfo.showGuestTermsWithoutCheckBox && !this.props.isSignUp &&
					<div className="guest-terms ppvx_row ppvx_justify-content-center ppvx_align-items-center mt-16 mb-16">
						<div
							className="ppvx_col-12 legal-text"
							dangerouslySetInnerHTML={this.createMarkup()}>
						</div>
					</div>
					
				}
				{countryInfo.showGuestTermsCheckBox && !this.props.isSignUp &&
					<div className="guest-terms ppvx_row ppvx_justify-content-center ppvx_align-items-center mt-16 mb-16">
						<Checkbox
							label={this.createMarkupSpan()}
							name="termsCheckbox"
							id="termsCheckbox"
							onChange={this.onChange}
							checked={this.state.isChecked}
							error={this.props.hasError}
							errorText={messages.pleaseConfirm}
						/>
					</div>
				}

				{countryInfo.showGuestTermsText &&
					<div className="guest-terms small ppvx_row ppvx_justify-content-center ppvx_align-items-center mt-16 mb-16">
						<div
							className="ppvx_col-12 legal-text text-center"
							dangerouslySetInnerHTML={this.createMarkup()}>
						</div>
					</div>
				}
			</React.Fragment>
		);
	}
}

GuestTerms.propTypes = {
	handleRequired: PropTypes.func,
	label: PropTypes.string,
	country: PropTypes.string,
	isSignUp: PropTypes.bool,
	mandatory: PropTypes.bool,
	isChecked: PropTypes.bool,
	hasError: PropTypes.bool,
};

export default GuestTerms
